<template>
  <b-container id="view" style="padding: 0">
    <Navbar></Navbar>
    <b-container>
      <b-row>
        <b-col>
          <FeaturedPodium></FeaturedPodium>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="9">
          <h2 class="title_section"><b-icon icon="square-fill" class="puce"></b-icon>Classement</h2>
          <p style="text-align: left">Les classements Coureur officiels seront établis grâce aux cumuls des points des 6 meilleures courses. Les coureurs qui ne participeront pas au moins à 8 courses du Challenge seront hors classement.</p>
          <WrapperClassement></WrapperClassement>
        </b-col>
        <b-col lg="3">
          <SliderCourse></SliderCourse>
          <h2 class="title_section"><b-icon icon="square-fill" class="puce"></b-icon>Calendrier</h2>
          <CalendrierCourse></CalendrierCourse>
        </b-col>
      </b-row>
    </b-container>
    <p style="font-size: 12px; padding-bottom: 10px; text-align: center">
      <b>Généré par </b> <a href="https://sportips.fr" target="_blank"><img src="https://sportips.fr/ressources/logo_menu.png" style="display: inline; width: 80px" /></a>
    </p>
  </b-container>
</template>

<script>
import SliderCourse from "@/components/BS_SliderCourse.vue";
import FeaturedPodium from "@/components/FeaturedPodium.vue";
import CalendrierCourse from "@/components/CalendrierCourse.vue";
import WrapperClassement from "@/components/Classement/Wrapper.vue";
import Navbar from "../components/Navbar.vue";

export default {
  name: "Classement",
  components: {
    SliderCourse,
    FeaturedPodium,
    WrapperClassement,
    CalendrierCourse,
    Navbar,
  },
};
</script>
